import { FunctionComponent } from "react";

import {
  FontIcon,
  Heading,
  Stack,
  Text,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize,
  useTheme
} from "@bps/fluent-ui";
import { AccScheduleTransactionStatuses } from "@libs/gateways/billing/BillingGateway.dtos.ts";
import { BillingTransactionStatusText } from "@ui-components/RefText.tsx";
import { TooltipHost } from "@ui-components/TooltipHost.tsx";

interface AuthorisedReceivedProps {
  label: string;
}

export const TransactionTransmissionStatusCellAuthorised: FunctionComponent<
  AuthorisedReceivedProps
> = ({ label }) => {
  const theme = useTheme();

  return (
    <TooltipHost
      calloutBgColor={theme.palette.themeLighterAlt}
      content={
        <Stack horizontalAlign="center">
          <Heading styles={{ root: { color: theme.palette.themeDarkAlt } }}>
            <BillingTransactionStatusText
              code={AccScheduleTransactionStatuses.Authorised}
            />
          </Heading>
          <Text>
            The state is reflecting internal ACC processing. Invoice has been
            authorised & is awaiting payment
          </Text>
        </Stack>
      }
    >
      <TextBadge
        badgeSize={TextBadgeSize.medium}
        badgeColor={TextBadgeColor.blue}
        horizontal
        horizontalAlign="center"
        tokens={{ childrenGap: 4 }}
        styles={{ root: { backgroundColor: theme.palette.themeLighterAlt } }}
      >
        <FontIcon iconName="info" styles={{ root: { fontSize: 16 } }} />
        <span>{label}</span>
      </TextBadge>
    </TooltipHost>
  );
};
